export const ZOOM_MIN = 0.5
export const ZOOM_MAX = 2
export const ZOOM_STEP = 0.1
export const FIT_MAX = 1.15
export const COMPACT_BELOW = 0.82
export const NARROW_QUERY = '(max-width: 1023px)'

export type FitMode = 'both' | 'width' | 'natural'
export type Pane = 'both' | 'std' | 'eff'

export function clamp(n: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, n))
}

export function planCanFill(root: HTMLElement | null): boolean {
  const parent = root?.parentElement
  if (!parent || typeof getComputedStyle !== 'function') return false
  const cs = getComputedStyle(parent)
  if (!cs.display.includes('flex')) return false
  const h = Number.parseFloat(cs.height)
  return Number.isFinite(h) && h > 240
}

export function resolveFitMode(mode: FitMode, fill: boolean, narrowBoth: boolean): FitMode {
  if (mode === 'natural') return 'natural'
  if (mode === 'width' || !fill || narrowBoth) return 'width'
  return 'both'
}

export function planFitScale(
  mode: FitMode,
  zoom: number,
  stageW: number,
  stageH: number,
  contentW: number,
  contentH: number,
): number {
  const z = clamp(zoom, ZOOM_MIN, ZOOM_MAX)
  if (mode === 'natural' || stageW <= 0 || contentW <= 0 || contentH <= 0) return z
  const widthRatio = (stageW - 2) / contentW
  if (mode === 'width' || stageH <= 0) return clamp(Math.min(widthRatio, FIT_MAX) * z, 0, ZOOM_MAX)
  const heightRatio = (stageH - 2) / contentH
  return clamp(Math.min(widthRatio, heightRatio, FIT_MAX) * z, 0, ZOOM_MAX)
}

export function planPillText(
  row: { sign: string; open: boolean; other_name: string },
  compact: boolean,
): string {
  const full = row.sign === 'plus'
    ? `angenommen · für ${row.other_name || 'unbekannt'}`
    : row.open
      ? 'offen'
      : `angenommen · ${row.other_name || 'unbekannt'}`
  if (!compact) return full
  if (row.sign === 'plus') return `+ ${row.other_name || 'dazu'}`
  if (row.open) return 'offen'
  return `− ${row.other_name || 'weg'}`
}
